module.exports = __webpack_public_path__ + "static/media/barnes.fee55ce5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/barnes.jpg
// module id = 198
// module chunks = 0